import { checkDocument } from '../../customLib';

const checkNewUser = () => {
	let justSignedUp = false;

	try {
		if (checkDocument()) {
			justSignedUp = window.localStorage.getItem('jsu') === '1';
		}
	} catch (err) {
		console.log(err);
	}

	return justSignedUp;
};

export const initialNewUser = {
	justSignedUp: checkNewUser(),
};

export const newUserActions = {
	// __checkNewUser: () => ({
	// 	justSignedUp: checkNewUser(),
	// }),
	__isNewUser: () => {
		if (checkDocument()) {
			window.localStorage.setItem('jsu', '1');
		}
		return {
			justSignedUp: true,
		};
	},
	__doneNewUser: () => {
		if (checkDocument()) {
			window.localStorage.removeItem('jsu');
		}
		return {
			justSignedUp: false,
		};
	},
	// __resetNewUser: () => ({
	// 	justSignedUp: false,
	// }),
};
